import axios from 'axios';

interface User {
  idToken: string;
  refreshToken: string;
  [key: string]: any;
}

export const http = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Response interceptor
http.interceptors.response.use(
  (response) => response,

  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        const userString = localStorage.getItem('user');
        let user: User | null = null;

        if (userString) {
          try {
            user = JSON.parse(userString);
          } catch {
            redirectToLogin();
            return Promise.reject(
              new Error('Invalid user data in localStorage')
            );
          }
        }

        const encryptedRefreshToken = user?.refreshToken || null;
        const refreshToken = encryptedRefreshToken
          ? decryptToken(encryptedRefreshToken)
          : null;

        if (!refreshToken) {
          redirectToLogin();
          return Promise.reject(error);
        }

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/UsersMi/authenticate`,
          { refreshToken }
        );
        const newToken = response.data.idToken;
        const encryptedNewToken = encryptToken(newToken);

        if (user) {
          user.idToken = encryptedNewToken;
          localStorage.setItem('user', JSON.stringify(user));
        }

        if (error.config.headers) {
          error.config.headers.Authorization = `Bearer ${newToken}`;
        } else {
          error.config.headers = { Authorization: `Bearer ${newToken}` };
        }
        return http(error.config);
      } catch (refreshError) {
        redirectToLogin();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

function redirectToLogin() {
  localStorage.removeItem('user');
  window.location.href = '/login';
}

function encryptToken(token: string) {
  return btoa(token);
}

function decryptToken(encryptedToken: string) {
  return atob(encryptedToken);
}
